import React, { useLayoutEffect } from 'react';
import Card from 'react-bootstrap/Card';
import cn from 'classnames';
import PropTypes from 'prop-types';
import { scrollToTop } from 'lib/scrollToTop';
import { AnalysisConnectionNotice } from 'features/connectivity';
import styles from './Processing.module.css';
import cardBack from 'assets/images/card_back@2x.png';
import idFront from 'assets/images/id_front@2x.png';

function Processing({ orientation }) {
    // Scroll to the top when this shows. Pages render it without a route change, so nothing else
    // resets the scroll.
    useLayoutEffect(() => {
        scrollToTop();
    }, []);

    return (
        <div className={styles.processsingWrapper}>
            <Card.Header as="h5" className={cn(styles.scanCardHeader, styles.processingCardHeader)}>
                Analyzing
            </Card.Header>
            <Card.Body className={styles.processingCardBody}>
                <div className="analyzing_container">
                    <figure className="analyzing_animation_zone">
                        <img width="100%" alt="idscango" src={orientation ? cardBack : idFront} />
                    </figure>
                </div>
                <div className={styles.connectionNotice}>
                    <AnalysisConnectionNotice />
                </div>
            </Card.Body>
        </div>
    );
}

Processing.propTypes = {
    orientation: PropTypes.oneOfType([PropTypes.number, PropTypes.bool]),
};

export default Processing;
